import * as ld from 'launchdarkly-js-client-sdk';

export function launchDarklyFactory(clientId: string, context: ld.LDContext): ld.LDClient {
  return ld.initialize(clientId, context);
}